module.exports = __webpack_public_path__ + "static/media/alibaba-background.24a47930.png";